
import { combineReducers } from 'redux'
import customerDataReducer from './customer/CustomerData'
import service from './service/service'
import task from './service/task'
import taskDetails from './service/taskDetails'
import loading from './service/loading'
import guaranteeCardsReducer from './guaranteeCards/GuaranteeCardsData'
import locationDataReducer from './location/locationData';
import popup from "./Common/popup";
import happycallDataReducer from "./service/HappyCallData";
import ComplaintsReducer from './service/Complaints';
import SystemSettingsReducer from './Common/SystemSettings';

const reducers = combineReducers({
  customerDataReducer,
  service,
  task,
  taskDetails,
  loading,
  guaranteeCardsReducer,
  locationDataReducer,
  happycallDataReducer,
  ComplaintsReducer,
  SystemSettingsReducer,
  popup
})


export default reducers;